import React, { useState, useRef, useEffect } from 'react';
import { connect } from 'react-redux';
import { css, StyleSheet } from 'aphrodite/no-important';
import { PopupMenu } from 'quantux-ui';
import { gray } from '../../theme';
import { debugLogToConsole } from '../../utils';

const LeftPinnedEllipsis = (props) => {
  const [showLeftPinnedEllipsisMenu, setShowLeftPinnedEllipsisMenu] = useState(false);
  const [canUpdateColor, setCanUpdateColor] = useState(false);
  const leftPinnedEllipsisMenuRef = useRef();

  const styles = StyleSheet.create({
    gridEllipsisMenuContainer: {
      background: '#103A60',
      width: '220px',
      maxWidth: '220px',
      minHeight: '80px',
      fontSize: '14px'
    },
    gridEllipsisMenuItem: {
      display: 'flex',
      alignItems: 'center',
      height: '32px',
      width: '100%',
      paddingLeft: '8px',
      background: '#103A60',
      color: gray[200],
      ':not(.active):hover': {
        background: '#0066CC',
        color: 'white'
      }
    }
  });

  useEffect(() => {
    const userId = props.usr._id;
    const accessMgrIdx = props.selectedPractice.accessManagers.findIndex(el => {
      const tmp = el._id === userId;
      return tmp;
    });

    if (props.usr.isMasterAdmin) {
      setCanUpdateColor(true);
      return;
    }

    if (accessMgrIdx > -1 && props.selectedPractice.accessManagers[accessMgrIdx].caseLedger >= 4) {
      setCanUpdateColor(true);
    }
  }, [
    props.usr.isMasterAdmin,
    props.selectedPractice.accessManagers
  ]);

  let title = 'Add Case Block';
  switch (props.assignmentType) {
    case 'directing':
      title = 'Add Direction Block';
      break;
    case 'call':
      title = 'Add Call Block';
      break;
    case 'shift':
      title = 'Add Shift Block';
      break;
    default:
      title = 'Add Case Block';
  }

  return (
    <div
      ref={leftPinnedEllipsisMenuRef}
      style={{ position: 'relative' }}
      onClick={() => {
        setShowLeftPinnedEllipsisMenu(!showLeftPinnedEllipsisMenu);
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        fill="none"
        className='ml-2'
      >
        <path fill="#96C8FF" fillRule="evenodd" d="M2 0a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2Zm3 10a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm12 2a2 2 0 1 1 4 0 2 2 0 0 1-4 0Zm-5-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4Z" clipRule="evenodd" />
      </svg>
      <PopupMenu
        top={26}
        right={5}
        position="absolute"
        zIndex="2501"
        visible={showLeftPinnedEllipsisMenu}
        parent={leftPinnedEllipsisMenuRef}
        onOutsideClick={() => { setShowLeftPinnedEllipsisMenu(false); }}
      >
        <div style={{ width: '150px', height: '64px', minHeight: '64px' }} className={css(styles.gridEllipsisMenuContainer)}>
          {/* Add Case Block */}
          <div
            className={css(styles.gridEllipsisMenuItem)}
            onClick={() => {
              setShowLeftPinnedEllipsisMenu(false);
              if (props.assignmentType === 'none') {
                props.openCaseBlocksDrawer();
              } else if (props.assignmentType === 'directing') {
                props.openDirectionDrawer();
              } else if (props.assignmentType === 'call') {
                props.openCallDrawer();
              } else if (props.assignmentType === 'shift') {
                props.openShiftDrawer();
              }
            }}
          >
            {title}
          </div>
          {/* Add Case */}
          <div
            className={css(styles.gridEllipsisMenuItem)}
            onClick={() => {
              props.openAddCaseDrawer();
              setShowLeftPinnedEllipsisMenu(false);
            }}
          >
            Add Case
          </div>
          {/* Select Location BG & Text color */}
          <div
            className={css(styles.gridEllipsisMenuItem)}
            onClick={props.showBgColorPicker}
            style={{ display: canUpdateColor ? '' : 'none' }}
          >
            Select Colors
          </div>
        </div>
      </PopupMenu>
    </div>
  );
};

function mapStateToProps({ user, caseSchedule }) {
  return {
    ...user,
    ...caseSchedule
  };
}

export default connect(mapStateToProps, {})(LeftPinnedEllipsis);
